import { gql } from '@apollo/client';

export const GET_API_KEY = gql`
  query ($serialNumber: String!) {
    getAPIKey(data: { equipmentSerialNumber: $serialNumber })
  }
`;
